import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './performanceReview.json';

const PerformanceReview = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            level="B2"
            title="Performance Reviews"
            image="/Images/advice.webp"
            seoTitle="Free English Lesson Plans: Performance Reviews"
            seoDescription="Performance reviews, feedback, and professional development discussions. B2 level grammar, vocabulary, and speaking exercises."
            description="Performance reviews, feedback, and professional development discussions. B2 level grammar, vocabulary, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default PerformanceReview;
